<div
  class="option-card"
  [class.option-card--selected]="type !== 'info' && selectedOption === (type === 'checkbox' ? true : option)"
  [class.option-card--no-content]="!option"
  [class.option-card--default-cursor]="type === 'info'"
  [tabindex]="type !== 'info' ? 0 : -1"
  [attr.role]="ariaRole"
  [attr.aria-checked]="ariaChecked"
  [attr.aria-label]="title"
  (click)="updateSelection(option)"
  (keydown.enter)="updateSelection(option)"
  (keydown.space)="updateSelection(option); $event.preventDefault()"
>
  <lx-image *ngIf="withImage" class="option-card__image" [image]="image" [fallbackImage]="fallbackImage" [width]="480" [height]="320" alt="Card image" />

  <div class="option-card__container" [class.option-card__container--with-image]="withImage" [class.option-card__container--content]="option">
    <div class="option-card__container__text">
      <div class="option-card__container__text__title">{{ title }}</div>
      <div class="option-card__container__text__description" [class.option-card__container__text__description--empty]="!option || !withImage">
        <ng-content></ng-content>
      </div>
    </div>
    <div
      class="option-card__container__type"
      [class.option-card__container__type--label]="label"
      [class.option-card__container__type--empty]="!label && !withImage"
    >
      <lx-offer-label-lite *ngIf="label" [text]="label"></lx-offer-label-lite>
      <div
        class="option-card__container__type__option"
        [ngClass]="{
          'option-card__container__type__option--radio': type === 'radio',
          'option-card__container__type__option--checkbox': type === 'checkbox'
        }"
      >
        <ng-container [ngSwitch]="type">
          <input type="radio" [value]="option" [(ngModel)]="selectedOption" *ngSwitchCase="'radio'" tabindex="-1" aria-hidden="true" />
          <p-checkbox [(ngModel)]="selectedOption" [binary]="true" *ngSwitchCase="'checkbox'" tabindex="-1" aria-hidden="true" />
        </ng-container>
      </div>
    </div>
  </div>
</div>
